import AIAssistantFa from './AIAssistant-fa.json';
import AIAssistantEn from './AIAssistant-en.json';
import AIAssistantAr from './AIAssistant-ar.json';
import AIAssistantTr from './AIAssistant-tr.json';

import BandHeroFa from './BandHero-fa.json';
import BandHeroEn from './BandHero-en.json';
import BandHeroAr from './BandHero-ar.json';
import BandHeroTr from './BandHero-tr.json';

import LifestyleCommonFa from './LifestyleCommon-fa.json';
import LifestyleCommonEn from './LifestyleCommon-en.json';
import LifestyleCommonAr from './LifestyleCommon-ar.json';
import LifestyleCommonTr from './LifestyleCommon-tr.json';

import PersonaFa from './Persona-fa.json';
import PersonaEn from './Persona-en.json';
import PersonaAr from './Persona-ar.json';
import PersonaTr from './Persona-tr.json';

import RingHeroFa from './RingHero-fa.json';
import RingHeroEn from './RingHero-en.json';
import RingHeroAr from './RingHero-ar.json';
import RingHeroTr from './RingHero-tr.json';

import TrackerHeroFa from './TrackerHero-fa.json';
import TrackerHeroEn from './TrackerHero-en.json';
import TrackerHeroAr from './TrackerHero-ar.json';
import TrackerHeroTr from './TrackerHero-tr.json';

import WatchHeroFa from './WatchHero-fa.json';
import WatchHeroEn from './WatchHero-en.json';
import WatchHeroAr from './WatchHero-ar.json';
import WatchHeroTr from './WatchHero-tr.json';

import finalCTA from './finalCTA.json';
import watchAssistant from './watchAssistant.json';

// Nested Component Translations
import HealthSensorsFa from '../HealthSensors/locales/fa/healthSensors.json';
import HealthSensorsEn from '../HealthSensors/locales/en/healthSensors.json';
import HealthSensorsAr from '../HealthSensors/locales/ar/healthSensors.json';
import HealthSensorsTr from '../HealthSensors/locales/tr/healthSensors.json';

import NonHealthFeaturesFa from '../NonHealthFeatures/locales/fa.json';
import NonHealthFeaturesEn from '../NonHealthFeatures/locales/en.json';
import NonHealthFeaturesAr from '../NonHealthFeatures/locales/ar.json';
import NonHealthFeaturesTr from '../NonHealthFeatures/locales/tr.json';

import TrackerFeatures from '../NonHealthFeatures/TrackerFeatures/trackerFeatures.json';

import BandFAQs from '../deta-FAQ/locales/bandFAQs.json';
import RingFAQs from '../deta-FAQ/locales/ringFAQs.json';
import TrackerFAQs from '../deta-FAQ/locales/trackerFAQs.json';
import WatchFAQs from '../deta-FAQ/locales/watchFAQs.json';

import { hardwareFeaturesLocales } from '../deta-HardwareFeatures/locales';

import { lifestyleLocales } from '../deta-LifestyleUseCases/locales';

import BandPainPreventionFa from '../SmartBandPainPrevention/locales/fa.json';
import BandPainPreventionEn from '../SmartBandPainPrevention/locales/en.json';
import BandPainPreventionAr from '../SmartBandPainPrevention/locales/ar.json';
import BandPainPreventionTr from '../SmartBandPainPrevention/locales/tr.json';

export const landingLocales = {
  fa: {
    AIAssistant: AIAssistantFa,
    BandHero: BandHeroFa,
    LifestyleCommon: LifestyleCommonFa,
    Persona: PersonaFa,
    ringHero: RingHeroFa,
    TrackerHero: TrackerHeroFa,
    WatchHero: WatchHeroFa,
    finalCTA: finalCTA.fa,
    watchAssistant: watchAssistant.fa,
    healthSensors: HealthSensorsFa,
    nonHealth: NonHealthFeaturesFa,
    trackerFeatures: TrackerFeatures.fa,
    bandFAQs: BandFAQs.fa,
    ringFAQs: RingFAQs.fa,
    trackerFAQs: TrackerFAQs.fa,
    watchFAQs: WatchFAQs.fa,
    hardwareFeatures: hardwareFeaturesLocales.fa,
    bandLifestyle: lifestyleLocales.fa.BandLifestyle,
    ringLifestyle: lifestyleLocales.fa.RingLifestyle,
    trackerLifestyle: lifestyleLocales.fa.TrackerLifestyle,
    watchLifestyle: lifestyleLocales.fa.WatchLifestyle,
    bandPainPrevention: BandPainPreventionFa
  },
  en: {
    AIAssistant: AIAssistantEn,
    BandHero: BandHeroEn,
    LifestyleCommon: LifestyleCommonEn,
    Persona: PersonaEn,
    ringHero: RingHeroEn,
    TrackerHero: TrackerHeroEn,
    WatchHero: WatchHeroEn,
    finalCTA: finalCTA.en,
    watchAssistant: watchAssistant.en,
    healthSensors: HealthSensorsEn,
    nonHealth: NonHealthFeaturesEn,
    trackerFeatures: TrackerFeatures.en,
    bandFAQs: BandFAQs.en,
    ringFAQs: RingFAQs.en,
    trackerFAQs: TrackerFAQs.en,
    watchFAQs: WatchFAQs.en,
    hardwareFeatures: hardwareFeaturesLocales.en,
    bandLifestyle: lifestyleLocales.en.BandLifestyle,
    ringLifestyle: lifestyleLocales.en.RingLifestyle,
    trackerLifestyle: lifestyleLocales.en.TrackerLifestyle,
    watchLifestyle: lifestyleLocales.en.WatchLifestyle,
    bandPainPrevention: BandPainPreventionEn
  },
  ar: {
    AIAssistant: AIAssistantAr,
    BandHero: BandHeroAr,
    LifestyleCommon: LifestyleCommonAr,
    Persona: PersonaAr,
    ringHero: RingHeroAr,
    TrackerHero: TrackerHeroAr,
    WatchHero: WatchHeroAr,
    finalCTA: finalCTA.ar,
    watchAssistant: watchAssistant.ar,
    healthSensors: HealthSensorsAr,
    nonHealth: NonHealthFeaturesAr,
    trackerFeatures: TrackerFeatures.ar,
    bandFAQs: BandFAQs.ar,
    ringFAQs: RingFAQs.ar,
    trackerFAQs: TrackerFAQs.ar,
    watchFAQs: WatchFAQs.ar,
    hardwareFeatures: hardwareFeaturesLocales.ar,
    bandLifestyle: lifestyleLocales.ar.BandLifestyle,
    ringLifestyle: lifestyleLocales.ar.RingLifestyle,
    trackerLifestyle: lifestyleLocales.ar.TrackerLifestyle,
    watchLifestyle: lifestyleLocales.ar.WatchLifestyle,
    bandPainPrevention: BandPainPreventionAr
  },
  tr: {
    AIAssistant: AIAssistantTr,
    BandHero: BandHeroTr,
    LifestyleCommon: LifestyleCommonTr,
    Persona: PersonaTr,
    ringHero: RingHeroTr,
    TrackerHero: TrackerHeroTr,
    WatchHero: WatchHeroTr,
    finalCTA: finalCTA.tr,
    watchAssistant: watchAssistant.tr,
    healthSensors: HealthSensorsTr,
    nonHealth: NonHealthFeaturesTr,
    trackerFeatures: TrackerFeatures.tr,
    bandFAQs: BandFAQs.tr,
    ringFAQs: RingFAQs.tr,
    trackerFAQs: TrackerFAQs.tr,
    watchFAQs: WatchFAQs.tr,
    hardwareFeatures: hardwareFeaturesLocales.tr,
    bandLifestyle: lifestyleLocales.tr.BandLifestyle,
    ringLifestyle: lifestyleLocales.tr.RingLifestyle,
    trackerLifestyle: lifestyleLocales.tr.TrackerLifestyle,
    watchLifestyle: lifestyleLocales.tr.WatchLifestyle,
    bandPainPrevention: BandPainPreventionTr
  }
};